import { CategoryDefaultForm } from './default.form';

export const CategoryCreateForm = Object.assign(CategoryDefaultForm, {});



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/categories/forms/category/create.form.ts